import { InjectionToken } from '@angular/core';
import { FlipperConfiguration } from '@flipper';
import type { UserContext } from '../models/user-context.type';

export const FLIPPER_CONFIGURATION = new InjectionToken<FlipperConfiguration>('FLIPPER_CONFIGURATION');

export const BROWSER_DATA = new InjectionToken<UserContext>('BROWSER_DATA');
